exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.icon {\n  position: relative;\n  top: 0.01rem;\n  display: inline-block;\n  width: 1em;\n  height: 1em;\n  stroke-width: 0;\n  stroke: currentColor;\n  fill: currentColor;\n}\nmain {\n  height: 100%;\n}\n.content {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0.6rem;\n  bottom: 0;\n}\n.content.show-guide {\n  overflow: hidden;\n}\n.dashboard {\n  height: 100%;\n  min-width: 13.5rem;\n  padding-left: 2.1rem;\n  border-left: 1px #e4e4e4 solid;\n  z-index: auto;\n  overflow-y: auto;\n}\n.clearfix {\n  zoom: 1;\n}\n.clearfix:after {\n  content: \" \";\n  display: block;\n  clear: both;\n  height: 0;\n}\n.page .el-tabs__active-bar,\n.page .el-table::after,\n.page .el-table::before {\n  z-index: 0;\n}\n.copyUrl {\n  position: absolute;\n  top: 0;\n  opacity: 0;\n  z-index: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-383b7d72","scoped":false,"hasInlineConfig":false}!./~/postcss-loader/lib?sourceMap!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=1!./app/components/CenterContent.vue
// module id = 599
// module chunks = 40